(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[965],{

/***/ 5665:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contributors",
      function () {
        return __webpack_require__(3845);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_contributors; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./components/layout/PageLayout.tsx + 4 modules
var PageLayout = __webpack_require__(2582);
// EXTERNAL MODULE: ./components/ui/Important.tsx
var Important = __webpack_require__(9001);
;// CONCATENATED MODULE: ./content/contributors.ts
var contributors = [
    {
        category: "Stallions",
        members: [
            {
                username: "perryd01",
                help: "Developer"
            },
            {
                username: "jsweazy",
                help: "Developer"
            },
            {
                username: "RealIndrit",
                help: "Developer"
            },
            {
                username: "GisliNielsen",
                help: "Developer"
            },
            {
                username: "amsuarez99",
                help: "Developer"
            },
            {
                username: "SpicyTakis",
                help: "Developer"
            },
            {
                username: "Aakara",
                help: "Developer"
            }, 
        ]
    },
    {
        category: "Graphics",
        members: [
            {
                username: "thorstendenk",
                help: "Main picture on front page"
            },
            {
                username: "vegardand",
                help: "Calendar image"
            }, 
        ]
    },
    {
        category: "Maintainers",
        members: [
            {
                username: "Tahtooz",
                help: "Spotify playlist, OCD"
            },
            {
                username: "DrStone",
                help: "Workout log"
            }, 
        ]
    },
    {
        category: "Fixes",
        members: [
            {
                username: "Freelancer",
                help: "Workout page"
            },
            {
                username: "TheBigWall",
                help: "Calendar entries"
            },
            {
                username: "JigaPlank",
                help: "Exercises, Design"
            },
            {
                username: "WaYa",
                help: "Tip"
            },
            {
                username: "Shatty",
                help: "Feedback"
            },
            {
                username: "Coleslaw",
                help: "Exercises"
            },
            {
                username: "xxtransience",
                help: "Exercises"
            },
            {
                username: "Ivarsen",
                help: "Exercises"
            },
            {
                username: "tyler718",
                help: "Exercises"
            },
            {
                username: "trumanblack",
                help: "Fix"
            },
            {
                username: "Vizumn",
                help: "Fix"
            },
            {
                username: "Hubert",
                help: "Fix"
            },
            {
                username: "Bakalaka",
                help: "Design"
            }, 
        ]
    }, 
];

// EXTERNAL MODULE: ./content/links.ts
var links = __webpack_require__(2304);
// EXTERNAL MODULE: ./content/text.ts
var content_text = __webpack_require__(9862);
;// CONCATENATED MODULE: ./pages/contributors.tsx






var ref, ref1, ref2, ref3;
var developers = (ref = contributors.find(function(e) {
    return e.category === "Stallions";
})) === null || ref === void 0 ? void 0 : ref.members;
var maintainers = (ref1 = contributors.find(function(e) {
    return e.category === "Maintainers";
})) === null || ref1 === void 0 ? void 0 : ref1.members;
var graphics = (ref2 = contributors.find(function(e) {
    return e.category === "Graphics";
})) === null || ref2 === void 0 ? void 0 : ref2.members;
var fixers = (ref3 = contributors.find(function(e) {
    return e.category === "Fixes";
})) === null || ref3 === void 0 ? void 0 : ref3.members;
var Contributors = function() {
    var og = {
        site_name: content_text/* seo.title */.$K.title,
        title: "Contributors - " + content_text/* seo.title */.$K.title,
        description: "Contributors who made this website possible",
        url: links/* baseUrl */.FH + "/contributors"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayout/* default */.Z, {
            openGraph: og,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-3xl mb-4 text-center font-bold",
                    children: "Contributors \uD83E\uDD47"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "py-5 text-center",
                                children: "Stallions"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: "w-96",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "p-2 text-left",
                                                    children: "Username"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "p-2 text-left",
                                                    children: "Topic"
                                                })
                                            ]
                                        })
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: developers === null || developers === void 0 ? void 0 : developers.map(function(developers, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                className: index % 2 === 0 ? "bg-knut-light-bg-info dark:bg-knut-dark-bg-info" : "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "p-2",
                                                        children: developers.username
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "p-2",
                                                        children: developers.help
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "py-10 text-center",
                                children: "Maintainers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: "w-96",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "p-2 text-left",
                                                    children: "Username"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "p-2 text-left",
                                                    children: "Topic"
                                                })
                                            ]
                                        })
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: maintainers === null || maintainers === void 0 ? void 0 : maintainers.map(function(maintainers, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                className: index % 2 === 0 ? "bg-knut-light-bg-info dark:bg-knut-dark-bg-info" : "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "p-2",
                                                        children: maintainers.username
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "p-2",
                                                        children: maintainers.help
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "py-10 text-center",
                                children: "Graphics"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: "w-96",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "p-2 text-left",
                                                    children: "Username"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "p-2 text-left",
                                                    children: "Topic"
                                                })
                                            ]
                                        })
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: graphics === null || graphics === void 0 ? void 0 : graphics.map(function(graphics, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                className: index % 2 === 0 ? "bg-knut-light-bg-info dark:bg-knut-dark-bg-info" : "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "p-2",
                                                        children: graphics.username
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "p-2",
                                                        children: graphics.help
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "py-10 text-center",
                                children: "Fixes"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: "w-96",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "p-2 text-left",
                                                    children: "Username"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "p-2 text-left",
                                                    children: "Topic"
                                                })
                                            ]
                                        })
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: fixers === null || fixers === void 0 ? void 0 : fixers.map(function(fixers, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                className: index % 2 === 0 ? "bg-knut-light-bg-info dark:bg-knut-dark-bg-info" : "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "p-2",
                                                        children: fixers.username
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "p-2",
                                                        children: fixers.help
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Important/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: "Should your name be here? "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-center",
                            children: [
                                "Contact",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: " Bitsnoxx#1337"
                                }),
                                " on Discord."
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var pages_contributors = (Contributors);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [154,555,131,774,888,179], function() { return __webpack_exec__(5665); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);